import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen pc-grid-bg flex items-center justify-center p-6">
      <div className="pc-card p-8 w-full max-w-md" data-testid="forgot-password-card">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center">
            <span className="text-white font-bold" style={{fontFamily:'Outfit'}}>P</span>
          </div>
          <div className="font-bold text-white text-lg" style={{fontFamily:'Outfit'}}>Compass PM</div>
        </Link>

        {sent ? (
          <>
            <h1 className="text-2xl font-semibold text-white mb-2" style={{fontFamily:'Outfit'}}>Check your email</h1>
            <p className="text-sm text-slate-400 mb-6" data-testid="forgot-password-sent">
              If an account exists for <span className="text-slate-200">{email}</span>, we just sent a reset link.
              The link expires in 30 minutes. Don't forget to check your spam folder.
            </p>
            <Link to="/login" className="inline-block text-blue-400 hover:text-blue-300 text-sm" data-testid="back-to-login-link">
              ← Back to sign in
            </Link>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-semibold text-white mb-1" style={{fontFamily:'Outfit'}}>Forgot password?</h1>
            <p className="text-sm text-slate-400 mb-6">Enter your email and we'll send a reset link.</p>
            <form onSubmit={onSubmit} className="space-y-3">
              <div>
                <label className="text-xs uppercase tracking-widest text-slate-400">Email</label>
                <input
                  data-testid="forgot-password-email"
                  type="email" required value={email}
                  onChange={(e)=>setEmail(e.target.value)}
                  className="w-full px-3 py-2.5 rounded-lg border focus:outline-none focus:border-blue-500" />
              </div>
              {err && <div data-testid="forgot-password-error" className="text-sm text-rose-400">{err}</div>}
              <button
                data-testid="forgot-password-submit" disabled={busy || !email}
                className="w-full bg-gradient-to-r from-blue-500 to-blue-700 text-white py-2.5 rounded-lg font-semibold shadow-lg shadow-blue-900/30 hover:from-blue-400 hover:to-blue-600 disabled:opacity-60">
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <div className="mt-6 text-sm text-slate-400 text-center">
              Remembered it? <Link to="/login" className="text-blue-400 hover:text-blue-300" data-testid="go-login-link">Sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
